import {
  FETCH_VOUCHERS_LIST,
  FETCH_VOUCHERS_LIST_FAILURE,
  FETCH_VOUCHERS_LIST_SUCCESS,
} from "../actions/types";

const initialState = {
  loading: false,
  error: null,
  voucherData: null,
};

const voucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VOUCHERS_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_VOUCHERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        voucherData: action.payload,
      };
    case FETCH_VOUCHERS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default voucherReducer;
